export default __webpack_public_path__ + "static/media/LucidaSansBold.fbaa2229.ttf";